<template>
  <b-container fluid>
    <b-row align-h="start">
      <b-col
        cols="auto"
        class="my-auto"
      >
        {{ testTypeSelected.name }} ({{ testTypeSelected.abbreviation }})
      </b-col>
      <b-col cols="auto">
        <b-row align-h="start">
          <b-col
            cols="auto"
            :class="{
              'col-left': true,
              'my-auto': true,
            }"
          >
            <b-button
              size="sm"
              :class="{
                'tab-button': true,
                'active': tabSelectedComputed === 'editTestType'
              }"
              @click="$emit('input', 'editTestType')"
            >
              ข้อมูลทั่วไป
            </b-button>
          </b-col>
          <b-col
            cols="auto"
            class="col-left my-auto"
          >
            <b-button
              :class="{
                'tab-button': true,
                'active': tabSelectedComputed === 'testType'
              }"
              size="sm"
              @click="$emit('input', 'testType')"
            >
              รายการผลตรวจ
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <template v-if="tabSelectedComputed === 'testType'">
      <b-row class="pt-3 mt-3 sub-panel">
        <b-col
          cols="auto"
          :class="{
            'col-left': true,
            'my-auto': true,
          }"
        >
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'createTest'
            }"
            @click="$emit('input', 'createTest')"
          >
            สร้างผลตรวจที่ {{ testTypeSelected ? testTypeSelected.name : null }}
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-row align-h="end">
            <template v-if="sequenceChange">
              <template v-if="tabSelectedComputed === 'testType'">
                <b-col
                  cols="auto"
                >
                  <b-button
                    size="sm"
                    variant="success"
                    @click="updateTestsSequenceHandler"
                  >
                    บันทึกลำดับ
                  </b-button>
                </b-col>
                <b-col
                  cols="auto"
                >
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="resetTestsSequenceHandler"
                  >
                    รีเซ็ตลำดับ
                  </b-button>
                </b-col>
              </template>
            </template>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
  export default {
    name: "TestTypeLevelTitle",
    props: {
      sequenceChange: {
        type: Boolean,
        default: false
      },
      testTypeSelected: {
        type: Object,
        default: () => null,
      },
      value: {
        type: String,
        default: 'testType'
      }
    },
    computed: {
      tabSelectedComputed: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      async resetTestsSequenceHandler() {
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการรีเซ็ตลำดับ',
          text: "คุณต้องการรีเซ็ตลำดับผลตรวจที่ได้เปลี่ยนแปลงไปใช่หรือไม่?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'รีเซ็ต',
          cancelButtonText: 'ยกเลิก',
        })

        if (confirm.value) {
          this.$emit('reset-test-sequence')
        }
      },
      async updateTestsSequenceHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('update-test-sequence', password)
        } else {
          return
        }

      },
    }
  }
</script>

<style lang="scss" scoped>
  .action-panel {
    opacity: 0;
    &.visible {
      opacity: 100%;
    }
  }

  .tab-button {
    &.active {
      background: #2E83D9 !important;
      color: white;
    }
  }

  .sub-panel {
    border-top: 1px solid black;
  }
</style>